// extracted by mini-css-extract-plugin
module.exports = {"info":"CoBorrowersInfo_info__1LkOI","name":"CoBorrowersInfo_name__3lvS3"};